import React from 'react';
import './index.less';
import { changeSourceUrl } from '@/utils/common';

interface HistoryListCardProps {
  // Define your props here
  historyList: any[],
}

const prefix = 'history-list-card';
const HistoryListCard: React.FC<HistoryListCardProps> = (props) => {
  const { historyList = [] } = props
  return (
    <div className={`${prefix}`}>
      {
        historyList?.map((item, index) => {
          return <div className={`${prefix}-item`} key={index}>
            <div className={`${prefix}-item-step`} >
              <div className={`${prefix}-item-step-t`}
                style={{ backgroundColor: index == 0 ? '#0F62FE' : '#CCCCCC' }}
              ></div>
              <div className={`${prefix}-item-step-line`} ></div>
            </div>
            <div className={`${prefix}-item-content`}>
              <div className={`${prefix}-item-content-title`}>由<span>{item?.operatorName}</span>更新于<span>{item?.operationTime}</span></div>
              <div className={`${prefix}-item-content-text`}>状态 {item?.oldValue} {
                item?.oldValue!=item?.newValue &&  <span>变更为 {item?.newValue}</span>
                }</div>
              <div className={`${prefix}-item-content-text`}>{item?.operationType}{item?.content ? <span>：  </span> : <></>}  {item?.content}</div>
              {/* {
                item?.userRoleType=='MEMBER' ?<>
              {item?.content&&<div className={`${prefix}-item-content-text`}>{item?.operationType}：  {item?.content}</div>}
                </>:<>
                  <div className={`${prefix}-item-content-text`}>{item?.operationType}</div>
              {item?.content&&<div className={`${prefix}-item-content-text`}>工单已答复：  {item?.content}</div>}
                </>
              } */}
              {
                item?.['fileList']?.length > 0 && <div className="list-row ">
                  <div className={`${prefix}-content-list-item common-list-card-content`} style={{display:'flex'}} >
                    <div className={`${prefix}-content-list-item-label`}>{'附件'}:</div>

                    <div className={`${prefix}-content-list-item-value attachment-list`}>
                      {
                        item?.['fileList'].map((item: any) => {
                          return <div className='hover-underline' key={item.id}>
                            <a
                              href={changeSourceUrl(item.url) }
                              download={item.name}
                              target="_self"
                              rel="noreferrer">
                              {
                                item.name
                              }
                            </a>
                          </div>
                        })}
                    </div>

                  </div>
                </div>
              }
            </div>
          </div>
        })
      }
    </div>
  );
};

export default HistoryListCard;
